<template>

         <div class="peoplemap-part"> 
            <div id="viewer" class="viewer" style="width: 100vw; height: 100vh;"></div>
            <div id="container"></div>
        </div>


</template>

<script>




import { Viewer } from '@photo-sphere-viewer/core';
import { MarkersPlugin } from '@photo-sphere-viewer/markers-plugin';
import { VisibleRangePlugin } from '@photo-sphere-viewer/visible-range-plugin';
import * as PANOLENS from 'panolens'


export default {
    name: 'App',
    data() {
        return {

    
        };
    },
    methods: {
      
     

    },
    mounted() {
   
            /*
            const animatedValues = {
                    pitch: { start: -Math.PI / 2, end: 0.2 },
                    yaw: { start: Math.PI, end: 0 },
                    zoom: { start: 0, end: 50 },
                    fisheye: { start: 2, end: 0 },
            };

            const viewer = new Viewer({
                container: document.querySelector('#viewer'),
                panorama: 'images/01-min.jpg',
                defaultPitch: -Math.PI / 2,
                defaultYaw: Math.PI,
                defaultZoomLvl: 0,
                fisheye: 2,
                navbar: [
                    'autorotate',
                    'zoom',
                    {
                        title: 'Rerun animation',
                        content: '🔄',
                        onClick: intro,
                    },
                    'caption',
                    'fullscreen',
                ],
                plugins: [
                    [AutorotatePlugin, {
                        autostartDelay: null,
                        autostartOnIdle: false,
                        autorotatePitch: 0.2,
                    }],
                ],
    
            });

            const autorotate = viewer.getPlugin(AutorotatePlugin);

            viewer.addEventListener('ready', intro, { once: true });
            function intro() {
                autorotate.stop();

                new Animation({ // eslint-disable-line
                    properties: animatedValues,
                    duration: 2500,
                    easing: 'inOutQuad',
                    onTick: (properties) => {
                        viewer.setOption('fisheye', 0);
                        viewer.rotate({ yaw: properties.yaw, pitch: properties.pitch });
                        viewer.zoom(properties.zoom);
                    },
                }).then(() => {
                    autorotate.start();
                });
            }
            */




             const viewer = new Viewer({
                container: document.querySelector('#viewer'),
                panorama: 'images/location3/3-0-1-min.jpg',
                defaultPitch: -0.5,
                defaultYaw: -0.1,
                defaultZoomLvl:20,
                
                navbar: [
                ],

                plugins: [

                    [MarkersPlugin, {
                        // list of markers
                        markers: [

 
                        {
                            id: 'location0311',
                            position: {
                                "yaw": 0,
                                "pitch": -0.3
                            },
                            html: '<div class="level1-btn"><div class="btn-title">'+this.data03[1].name+'</div></div>',
                            scale: [1, 1],
                            hoverScale: 1.1,

                        }, 
                           {
                                id: 'location04',
                                position: {
                                    "yaw": -2.2,
                                    "pitch": 0.4
                                },
                                html: '<div class="upper-btn"><div class="btn-title">'+this.data04[0].area+'</div><div class="upper-btn-img"><img src="'+this.PicturePath(this.data04[0].mainimg)+'"><div></div></div>',
                                scale: [0.8, 0.8],
                                hoverScale: 1.1,
                            }, 
                            {
                                id: 'location01',
                                position: {
                                    "yaw": -2,
                                    "pitch": 0.6
                                },
                                html: '<div class="upper-btn"><div class="btn-title">'+this.data01[0].area+'</div><div class="upper-btn-img"><img src="'+this.PicturePath(this.data01[0].mainimg)+'"><div></div></div>',
                                scale: [0.8, 0.8],
                                hoverScale: 1.1,
                            },
                            {
                                id: 'location02',
                                position: {
                                    "yaw": -1.8,
                                    "pitch": 0.4
                                },
                                html: '<div class="upper-btn"><div class="btn-title">'+this.data02[0].area+'</div><div class="upper-btn-img"><img src="'+this.PicturePath(this.data02[0].mainimg)+'"><div></div></div>',
                                scale: [0.8, 0.8],
                                hoverScale: 1.1,
                            },          
                              {
                                id: 'location07',
                                position: {
                                    "yaw": -1.6,
                                    "pitch": 0.6
                                },
                                html: '<div class="upper-btn"><div class="btn-title">'+this.data07[0].area+'</div><div class="upper-btn-img"><img src="'+this.PicturePath(this.data07[0].mainimg)+'"><div></div></div>',
                                scale: [0.8, 0.8],
                                hoverScale: 1.1,
                            },    
                            {
                                id: 'location05',
                                position: {
                                    "yaw": -1.4,
                                    "pitch": 0.4
                                },
                                html: '<div class="upper-btn"><div class="btn-title">'+this.data05[0].area+'</div><div class="upper-btn-img"><img src="'+this.PicturePath(this.data05[0].mainimg)+'"><div></div></div>',
                                scale: [0.8, 0.8],
                                hoverScale: 1.1,
                            },  
     

                        ],
                    
                    }],
                    [VisibleRangePlugin, {
                        //verticalRange: [-Math.PI / 1, Math.PI / 4],
                    }],
                ],
            });

            const self = this

            const markersPlugin = viewer.getPlugin(MarkersPlugin);
            markersPlugin.addEventListener('select-marker', ({ marker }) => {
                self.link(marker);    
                if (marker.id === 'inf') {
                    this.openrightmenu();      
                }
                if (marker.id === 'photo') {
                    this.album();
                }                                                
            });   

            viewer.addEventListener('ready', () => {
                viewer
                    .animate({

                    })
                    .then(() => {
                            //markersPlugin.showMarkerTooltip('text1');
                            
                    });

            }, { once: true });
              
            //vr盒
            var panorama, viewer2, container;
            container = document.querySelector( '#container' );
            panorama = new PANOLENS.ImagePanorama( 'images/location3/3-0-1-min.jpg' );
            viewer2 = new PANOLENS.Viewer( {  container: container } );
            viewer2.enableEffect( PANOLENS.MODES.STEREO ); 
            viewer2.add( panorama);
          

        }
}
</script>


<style scoped>

</style>
